import React from 'react';
import YoutubeVideosApi from '../../components/admin/YoutubeVideosApi';

const YoutubeVideosApiPage = () => {
  return <YoutubeVideosApi />;
};

export default YoutubeVideosApiPage;
